module.exports = __webpack_public_path__ + "static/media/uoa-17.d9a9537e.jpg";